import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import BRZ from "../../../../assets/info/brz-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import part1 from "../../../../assets/info/subaru-brz/subaru-ezi.jpg";
import styled from "styled-components";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const SubaruBRZ = () => {
  useSmallNav("Subaru BRZ");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Subaru BRZ"} bolder />
        <InfoHero image={BRZ} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={"Jeśli posiadasz Subaru BRZ, to dobrze trafiłeś!"}
            />
            <InfoHeader
              size="smaller"
              text={
                "Firma Pedders Suspension oferuje pełną gamę produktów do zawieszenia pasujących do Twojego Subaru BRZ i spełniających wszystkie Twoje potrzeby."
              }
            />
            <p>
              Oferujemy 3 poziomy ulepszeń zawieszenia dla Twojego BRZ, sprężyny
              obniżające SportsRyder, zestaw zawieszenia SportsRyder Ezifit i
              nasze zestawy gwintowane eXtreme XA.
            </p>
            <InfoHeader smaller text={"Sprężyny obniżające SportsRyder"} />
            <p>
              Sprężyny obniżające Pedders SportsRyder robią dokładnie to, co
              mówią. Idealny dla tych, którzy szukają poprawy wyglądu, ten
              zestaw składa się z 4 sprężyn obniżających Pedders SportsRyder do
              Twojego BRZ. Zastępują one po prostu oryginalne sprężyny Toyoty.
              Sprężyny śrubowe Pedders stanowią podstawę nowoczesnego układu
              zawieszenia obniżającego. Ich sztywność oraz wysokość „z
              obciążeniem”, czyli po zamontowaniu, mają zasadniczy wpływ na
              dynamikę podwozia, równowagę pojazdu i jakość jazdy. Oczywiście
              wysokość ładunku określa wysokość pojazdu oraz jego wykończenie
              lub położenie.
            </p>
            <p>
              Cewki Pedders SportsRyder zostały zaprojektowane i skonstruowane
              zgodnie z najwyższymi standardami jakości, aby zapewnić
              niezrównaną wydajność, spójność i niezawodność.
            </p>
            <p>
              Dzięki sprężynom śrubowym Pedders SportsRyder prowadzenie
              większości pojazdów ulega znacznej poprawie poprzez zwiększenie
              pierwotnego napięcia sprężyny do wartości, która zmniejsza
              przechyły nadwozia, a co za tym idzie, poprawia przyczepność opon
              - bez powodowania nadmiernej szorstkości i sztywności.
              Projektowanie i produkcja sprężyn śrubowych to rzemiosło
              wymagające ścisłego przestrzegania szeregu wymagających procedur,
              z których wszystkie mają kluczowe znaczenie dla wydajności
              produktu końcowego.
            </p>
            <p>Kluczowe cechy:</p>
            <ul>
              <li>25 mm niższy niż standardowy,</li>
              <li>lepsze pokonywanie zakrętów i prowadzenie,</li>
              <li>pasuje do oryginalnego zawieszenia Toyoty,</li>
              <li>wszystko objęte naszą 2-letnią gwarancją / 40 000 klm.</li>
            </ul>
            <InfoHeader
              smaller
              text={"Zestaw zawieszenia SportsRyder Ezifit"}
            />
            <p>
              To przeniesie Cię na wyższy poziom. Wykorzystując te same świetne
              sprężyny obniżające SportsRyder, dodaliśmy teraz amortyzatory
              Pedders SportsRyder. Są to ulepszone jednostki, charakteryzujące
              się poprawionym współczynnikiem tłumienia dla lepszej kontroli,
              aby dopasować je do sprężyn śrubowych Pedders SportsRyder. Ten
              zestaw jest idealny dla kogoś, kto szuka lepszego wyglądu i
              lepszej obsługi, ale bez uszczerbku dla komfortu. Aby uczynić go
              jak najbardziej Ezi, zestaw ten jest wyposażony w całkowicie
              zmontowane przednie kolumny, dzięki czemu jest prosta i nie wymaga
              żadnych modyfikacji. Obniżony wygląd i świetne prowadzenie z
              przyzwoitą jazdą w atrakcyjnej cenie - wszystko w wstępnie
              zmontowanym zestawie EziFit.
            </p>
            <p>Kluczowe cechy:</p>
            <ul>
              <li>
                Zestaw zawieszenia Pedders SportsRyder EziFit to idealna
                alternatywa dla kupowania oddzielnych komponentów gdy chcesz
                obniżyć BRZ.
              </li>
              <li>
                Krótszy czas montażu i przyzwoita równowaga między jazdą a
                prowadzeniem to kluczowe korzyści wynikające ze stosowania
                zestawu Pedders EziFit, ponieważ sprężyny, rozpórki i mocowania
                są dostarczane w stanie wstępnie zmontowanym i gotowym do
                montażu. Nie ma potrzeby używania ściągacza do sprężyn, ponieważ
                praca została już wykonana za Ciebie! Po prostu odkręć stare i
                przykręć nowe zawieszenie - PLUG &amp; PLAY w najlepszym
                wydaniu!
              </li>
              <li>
                Dostarczany jako DOPASOWANY ZESTAW wstępnie zmontowanych
                elementów zawieszenia, w tym amortyzatory gazowe Pedders
                SportsRyder, obniżone sprężyny śrubowe Pedders SportsRyder,
                odboje oraz zestaw osłon mocowania amortyzatorów.
              </li>
              <li>
                Krótszy czas instalacji, ponieważ komponenty są dostarczane w
                stanie wstępnie zmontowanym i gotowym do bezpośredniego montażu.
              </li>
              <li>
                Indywidualnie testowany na hamowni jako kompletny system
                zawieszenia współpracujący z istniejącym O.E. sprzęt
                zapewniający jakość i wydajność.
              </li>
              <li>Pedders EziFit obniży Twoje Subaru o około 25 mm.</li>
              <li>
                Amortyzatory gazowe Pedders SportsRyder w zestawie EziFit są
                wykonane w technologii dwururowej konstrukcji gazowej o dużej
                wytrzymałości i wzmocnionych, podwójnie spawanych mocowań
                zapewniających długoterminową trwałość.
              </li>
              <li>
                Kompletny zestaw to system zaprojektowany i wyposażony w zawory
                do współpracy. Doświadczysz dynamicznej, sportowej jazdy i
                prowadzenia, które nadają się do codziennej jazdy, a także do
                jazdy wyczynowej bez trudnych warunków jazdy.
              </li>
              <li>Wszystko objęte naszą 2-letnią gwarancją / 40 000 km.</li>
            </ul>
            <InfoHeader
              smaller
              text={"Zestaw gwintowany SportsRyder eXtreme XA"}
            />
            <p>
              Jeśli szukasz najlepszego prowadzenia i reakcji zawieszenia, nie
              szukaj dalej niż zestaw Pedders SportsRyder eXtreme XA. Ten zestaw
              oferuje zarówno regulowaną twardość, jak i regulowaną wysokość
              jazdy. Na czele zawieszenia sportowego stoi SportsRyder eXtreme
              XA, kolumny z regulacją wysokości, nierówności i odbicia oraz
              tuleje gwintowane, zbudowane zgodnie z rygorystycznymi standardami
              jakości Pedders. Charakteryzują się sportowym, regulowanym
              tłumieniem, sprężynami śrubowymi do sportów motorowych
              indywidualnie dopasowywanymi do każdego zastosowania oraz
              szeregiem funkcji o wysokiej wydajności, w tym specjalnie
              zaprojektowanymi wspornikami montażowymi. Gama gwintów eXtreme XA
              to szczyt technologii wyczynowych zawieszeń i flagowy asortyment
              specjalistycznych zawieszeń SportsRyder firmy Pedders w Australii.
            </p>
            <p>Kluczowe cechy:</p>
            <ul>
              <li>Regulacja tłumienia uderzenia i odbicia w 30 pozycjach.</li>
              <li>
                W pełni regulowane dolne mocowanie ze stali wysokiej jakości
                umożliwiające regulację wysokości.
              </li>
              <li>W pełni gwintowany korpus jednorurowy,</li>
              <li>Wysokiej jakości aluminiowe siedzenia sprężynowe.</li>
              <li>
                Wsporniki w stylu fabrycznym umożliwiające bezpośredni,
                bezproblemowy montaż.
              </li>
              <li>Sprężyny śrubowe ze stali stopowej do sportów motorowych.</li>
              <li>
                Zintegrowana osłona przeciwpyłowa chroniąca wał i uszczelkę.
              </li>
              <li>W pełni zmontowane górne mocowania.</li>
              <li>Wszystko objęte naszą 2-letnią gwarancją / 40 000 klm.</li>
            </ul>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Subaru")
              .models.find((e) => e.display === "BRZ")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <Gray>
              <InfoHeader
                size="smaller"
                text={"Zestawy zawieszenia Subaru BRZ SportsRyder Ezifit"}
              />
              <div>
                <StyledImgParts src={part1} alt="Outback Suspension Kits" />
              </div>
            </Gray>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/B3_fP64yhR0"
              title={"Subaru BRZ Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"Subaru BRZ Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Subaru BRZ Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Subaru" model="BRZ" /> */}
      </Container>
    </section>
  );
};

export default SubaruBRZ;

const StyledImgParts = styled.img`
  width: 100%;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
